// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.popupImagesGallery {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: #000e;
  z-index: 10000;
}

.popupImagesGallery__container {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
}

.popupImagesGallery__image {
  width: 100%;
  height: 100%;
  max-width: 45rem;
  max-height: 30rem;
  margin: auto;
  object-fit: contain;
  position: relative;
  z-index: 10;
}

.popupImagesGallery__imgContainer .loading-dot {
  position: absolute;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  font-size: 0.8rem;

}
.popupImagesGallery__imgContainer .loading-dot span{
  background: #fff9;
  margin-bottom: 3rem;
}

.popupImagesGallery__imgContainer {
  /* background-color: var(--clr-gray400); */
  width: 100%;
  height: 100%;
  max-width: 45rem;
  max-height: 30rem;
  margin: auto;
  object-fit: contain;
  overflow: hidden;
  position: relative;
}
/* 
.popupImagesGallery__imgContainer::after {
  display: block;
  content: "";
  position: absolute;
  top: 0;
  width: 100%;
  height: 100%;
  max-width: 45rem;
  transform: translateX(-100%);
  background: -webkit-gradient(
    linear,
    left top,
    right top,
    from(transparent),
    color-stop(rgba(255, 255, 255, 0.74)),
    to(transparent)
  );

  background: linear-gradient(
    90deg,
    transparent,
    rgba(255, 255, 255, 0.74),
    transparent
  );

  animation: loadingSkeleton 0.8s infinite;
} */

.popupImagesGallery__container .swiper-slide {
  height: 30rem !important;
  width: 100% !important;
  place-items: center;
  display: grid;
}
`, "",{"version":3,"sources":["webpack://./src/components/PopupImagesGallery/PopupImagesGallery.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,iBAAiB;EACjB,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,MAAM;EACN,OAAO;EACP,SAAS;EACT,QAAQ;EACR,iBAAiB;;AAEnB;AACA;EACE,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,0CAA0C;EAC1C,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,iBAAiB;EACjB,YAAY;EACZ,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;AACpB;AACA;;;;;;;;;;;;;;;;;;;;;;;;;;;GA2BG;;AAEH;EACE,wBAAwB;EACxB,sBAAsB;EACtB,mBAAmB;EACnB,aAAa;AACf","sourcesContent":[".popupImagesGallery {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: #000e;\n  z-index: 10000;\n}\n\n.popupImagesGallery__container {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  width: 100%;\n  height: 100%;\n}\n\n.popupImagesGallery__image {\n  width: 100%;\n  height: 100%;\n  max-width: 45rem;\n  max-height: 30rem;\n  margin: auto;\n  object-fit: contain;\n  position: relative;\n  z-index: 10;\n}\n\n.popupImagesGallery__imgContainer .loading-dot {\n  position: absolute;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 100%;\n  height: 100%;\n  top: 0;\n  left: 0;\n  bottom: 0;\n  right: 0;\n  font-size: 0.8rem;\n\n}\n.popupImagesGallery__imgContainer .loading-dot span{\n  background: #fff9;\n  margin-bottom: 3rem;\n}\n\n.popupImagesGallery__imgContainer {\n  /* background-color: var(--clr-gray400); */\n  width: 100%;\n  height: 100%;\n  max-width: 45rem;\n  max-height: 30rem;\n  margin: auto;\n  object-fit: contain;\n  overflow: hidden;\n  position: relative;\n}\n/* \n.popupImagesGallery__imgContainer::after {\n  display: block;\n  content: \"\";\n  position: absolute;\n  top: 0;\n  width: 100%;\n  height: 100%;\n  max-width: 45rem;\n  transform: translateX(-100%);\n  background: -webkit-gradient(\n    linear,\n    left top,\n    right top,\n    from(transparent),\n    color-stop(rgba(255, 255, 255, 0.74)),\n    to(transparent)\n  );\n\n  background: linear-gradient(\n    90deg,\n    transparent,\n    rgba(255, 255, 255, 0.74),\n    transparent\n  );\n\n  animation: loadingSkeleton 0.8s infinite;\n} */\n\n.popupImagesGallery__container .swiper-slide {\n  height: 30rem !important;\n  width: 100% !important;\n  place-items: center;\n  display: grid;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
